import { show, slideDown, slideUp } from "./Helpers/animations";
import { deleteCookie, getCookie } from "./Helpers/cookie";
import { createElement } from "./Helpers/createElement";

const siteControlId = (document.querySelector('meta[name=sitecontrolID]') as HTMLMetaElement)?.content ?? '';
const globalAlertsContainer = document.querySelector('header .global-alerts');
const alerts = document.querySelectorAll('header .global-alerts .alert') as NodeListOf<HTMLLIElement>;

if (globalAlertsContainer && alerts.length > 0) {
    const header = document.querySelector('header') as HTMLElement | null;
    const innerAlertsContainer = globalAlertsContainer.querySelector('.alerts') as HTMLDivElement | null;
    const viewAlertsButton = globalAlertsContainer.querySelector('.view-alerts') as HTMLButtonElement | null;
    const alertCount = globalAlertsContainer.querySelector('.alert-count') as HTMLElement | null;
    const viewIcon = globalAlertsContainer.querySelector('.view-icon') as HTMLElement | null;
    const viewText = globalAlertsContainer.querySelector('.view-text') as HTMLElement | null;
    const screenReaderText = viewAlertsButton?.querySelector('.sr-only') as HTMLSpanElement | null ?? null;

    if (viewAlertsButton?.dataset?.alertids) {
        const alertIds: string[] = viewAlertsButton.dataset.alertids.split('|');
        const dismissedAlertsCookie = getCookie(`Sonoma_${siteControlId}_Alerts`) ?? '';
        let dismissedAlerts: string[] = [];
        let dialogOpened = false;
        let newAlerts = 0;

        if (dismissedAlertsCookie) {
            const splitStatusAlerts = dismissedAlertsCookie.split(':');

            if (splitStatusAlerts.length > 0) {
                dialogOpened = splitStatusAlerts[0] === 'opened';

                if (splitStatusAlerts[1]) {
                    dismissedAlerts = splitStatusAlerts[1].split('|');
                }
            }
        }

        const newAlertIndicator = createElement('span', {
            classes: ['new-alert-indicator'],
            innerText: 'New'
        });

        alertIds.forEach(alertId => {
            if (!dismissedAlerts.includes(alertId)) {
                newAlerts++;
                const alertLink = document.getElementById(alertId);
                alertLink?.classList.add('new-alert');
                alertLink?.after(newAlertIndicator.cloneNode(true));
            }
        });

        if (alertCount && viewIcon && viewText && viewAlertsButton && innerAlertsContainer) {
            if (newAlerts > 0) {
                alertCount.innerText = newAlerts > 1 ? `${newAlerts} new alerts` : '1 new alert';
                viewIcon.classList.add('hidden');
            } else {
                alertCount.innerText = alertIds.length > 1 ? `${alertIds.length} alerts` : '1 alert';
                globalAlertsContainer.classList.add('viewed');
                viewText.classList.add('hidden');
            }

            if (dialogOpened) {
                globalAlertsContainer.classList.remove('closed');
                globalAlertsContainer.classList.add('opened', 'viewed');
                viewAlertsButton.ariaExpanded = 'true';
                viewAlertsButton.querySelector('i')?.classList.remove('hidden');
                viewAlertsButton.querySelector('.view-text')?.classList.add('hidden');
                if (screenReaderText) screenReaderText.innerText = 'Hide Alerts';
                show(innerAlertsContainer);

                const headerHeight = header ? parseInt(window.getComputedStyle(header).height.replace('px', '')) : 0;

                if (window.innerWidth < 395 && window.innerHeight - 44 - headerHeight < innerAlertsContainer.scrollHeight) {
                    innerAlertsContainer.style.height = `${window.innerHeight - 44 - headerHeight}px`;
                    innerAlertsContainer.style.overflowY = 'scroll';
                    document.documentElement.classList.add('behind');
                } else {
                    innerAlertsContainer.style.removeProperty('height');
                }
            }
        }

        if (alertCount && viewIcon && viewText && viewAlertsButton && innerAlertsContainer) {
            const alertLinks = [...innerAlertsContainer.querySelectorAll('.alert-link') as NodeListOf<HTMLAnchorElement>];

            const setAlertsCookie = () => {
                if (globalAlertsContainer.classList.contains('viewed') && globalAlertsContainer.classList.contains('opened')) {
                    document.cookie = `Sonoma_${siteControlId}_Alerts=closed:${viewAlertsButton.dataset.alertids};Max-Age=2592000;SameSite=Strict;Path=/;`;
                } else if (globalAlertsContainer.classList.contains('viewed')) {
                    document.cookie = `Sonoma_${siteControlId}_Alerts=opened:${viewAlertsButton.dataset.alertids};Max-Age=2592000;SameSite=Strict;Path=/;`;
                } else if (globalAlertsContainer.classList.contains('closed')) {
                    let alertsSeenString = getCookie(`Sonoma_${siteControlId}_Alerts`);
                    if (alertsSeenString) {
                        alertsSeenString = alertsSeenString.replace('opened:', '').replace('closed:', '');
                        document.cookie = `Sonoma_${siteControlId}_Alerts=opened;${alertsSeenString};Max-Age=2592000;SameSite=Strict;Path=/;`;
                    } else {
                        document.cookie = `Sonoma_${siteControlId}_Alerts=opened;Max-Age=2592000;SameSite=Strict;Path=/;`;
                    }
                }
            };

            const hideAlertsList = () => {
                globalAlertsContainer.classList.remove('closed');
                globalAlertsContainer.classList.add('opened');
                viewAlertsButton.disabled = true;

                slideUp(innerAlertsContainer, 200, {
                    callback: () => {
                        innerAlertsContainer.style.removeProperty('height');
                        document.documentElement.classList.remove('behind');

                        globalAlertsContainer.classList.add('viewed');
                        viewAlertsButton.ariaExpanded = 'false';
                        viewAlertsButton.disabled = false;
                        viewIcon.classList.remove('hidden');
                        viewText.classList.add('hidden');

                        if (screenReaderText) screenReaderText.innerText = 'Show All Alerts';
                        viewAlertsButton.focus();
                        globalAlertsContainer.classList.add('closed');
                        globalAlertsContainer.classList.remove('opened');
                    }
                });   
            };

            const showAlertsList = (focusElement: 'first' | 'last') => {
                viewAlertsButton.disabled = true;
                globalAlertsContainer.classList.remove('closed');
                globalAlertsContainer.classList.add('opened', 'viewed');
                
                slideDown(innerAlertsContainer, 200, {
                    callback: () => {
                        const headerHeight = header != null ? parseInt(window.getComputedStyle(header).height.replace('px', '')) : 0;
                        if (window.innerWidth < 395 && window.innerHeight - 44 - headerHeight < innerAlertsContainer.scrollHeight) {
                            innerAlertsContainer.style.height = `${window.innerHeight - 44 - headerHeight}px`;
                            innerAlertsContainer.style.overflowY = 'scroll';
                        }

                        globalAlertsContainer.classList.add('viewed');
                        viewAlertsButton.ariaExpanded = 'true';
                        viewAlertsButton.disabled = false;
                        viewIcon.classList.remove('hidden');
                        viewText.classList.add('hidden');

                        if (screenReaderText) screenReaderText.innerText = 'Hide Alerts';
                        
                        if (focusElement === 'first') {
                            alertLinks[0].focus();
                        } else {
                            alertLinks[alertLinks.length - 1].focus();
                        }
                    }
                });  
            };

            viewAlertsButton?.addEventListener('click', () => {
                setAlertsCookie();

                if (window.getComputedStyle(innerAlertsContainer).display !== 'none') {
                    hideAlertsList();
                } else {
                    showAlertsList('first');
                }
            });

            viewAlertsButton?.addEventListener('keydown', event => {
                if (window.getComputedStyle(innerAlertsContainer).display !== 'none') {
                    if (event.key === 'Escape') {
                        hideAlertsList();
                    } else {
                        switch (event.key) {
                            case 'ArrowDown':
                                event.preventDefault();
                                (innerAlertsContainer.querySelector('.alert-link') as HTMLAnchorElement | null)?.focus();
                                break;
                            case 'ArrowUp':
                            case 'End':    
                            event.preventDefault();
                                alertLinks[alertLinks.length - 1].focus();
                                break;
                            default: break;
                        }
                    }
                } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
                    event.preventDefault();
                    setAlertsCookie();
                    showAlertsList(event.key === 'ArrowUp' ? 'last' : 'first');
                }
            });

            alertLinks.forEach(alertLink => alertLink.addEventListener('keydown', event => {
                const currentLinkIndex = alertLinks.indexOf(alertLink);
                switch (event.key) {
                    case 'Escape':
                        viewAlertsButton.click();
                        break;
                    case 'ArrowUp':
                        event.preventDefault();
                        if (currentLinkIndex === 0) {
                            viewAlertsButton.focus();
                        } else if (alertLinks[currentLinkIndex - 1]) {
                            alertLinks[currentLinkIndex - 1].focus();
                        } else {
                            alertLinks[alertLinks.length - 1]?.focus();
                        }
                        break;
                    case 'ArrowDown':
                        event.preventDefault();
                        if (alertLinks[currentLinkIndex + 1]) {
                            alertLinks[currentLinkIndex + 1].focus();
                        } else {
                            viewAlertsButton.focus();
                        }
                        break;
                    case 'Home':
                        event.preventDefault();
                        viewAlertsButton.focus();
                        break;
                    case 'End':
                        event.preventDefault();
                        alertLinks[alertLinks.length - 1].focus();
                        break;
                }
            }));
        }
    } else {
        deleteCookie(`Sonoma_${siteControlId}_Alerts`);
    }
} else {
    deleteCookie(`Sonoma_${siteControlId}_Alerts`);
}